<div>
  <appMetadataWidget [data]="data"></appMetadataWidget>
  <app-metadata-field [data]="data"></app-metadata-field>
  <!-- <appMetadataInput [data]="data"></appMetadataInput> -->
  <div [formGroup]="form" id="form">
    <div class="metadata-block">
      <div class="metadata-key" for="label" title="{{ data.id }}">Label</div>
      <div class="metadata-input-block">
        <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
        <input tabindex="1" fxFlex="flex-grow" formControlName="heading" class="metadata-input-field" id="label" type="text"
          placeholder="{{ data.label }}" />
      </div>
      <div *ngIf="form?.get('heading')?.hasError('maxlength')" class="error-msg">Max 30 characters are allowed</div>

      <div class="metadata-key" for="desc">Description</div>
      <div class="metadata-input-block">
        <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
        <input tabindex="1" fxFlex="flex-grow" class="metadata-input-field" formControlName="description" id="desc" type="text" />
      </div>
      <div *ngIf="form?.get('description')?.hasError('maxlength')" class="error-msg">Max 100 characters are allowed
      </div>
    </div>
    <!-- Comments -->    
    <div class="metadata-block" fxLayout="row wrap">
      <div class="metadata-title">Comment</div>         
    </div>    
    <div class="metadata-block" fxLayout="row wrap">         
      <div class="metadata-properties">
        <div class="metadata-key" for="commentKey" title="{{ data.id }}">Key</div>
        <div class="metadata-input-block">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input tabindex="1" fxFlex="flex-grow" formControlName="commentKey" class="metadata-input-field" id="commentKey" type="text"
            placeholder="{{ data.commentKey }}" (change)="onChangeCommentKey($event)" />
        </div>
        <div *ngIf="form?.get('heading')?.hasError('maxlength')" class="error-msg">Max 30 characters are allowed</div>
      </div>
      <div class="metadata-block" fxLayout="row wrap">
        <div class="metadata-properties" fxLayout="row nowrap" *ngIf="form.get('commentKey')?.value !== ''">
          <label class="metadata-key" for="otherFlag">Conditional Comment Optional</label>
          <input tabindex="1" class="metadata-value" id="commentFieldOnOptional" 
            type="checkbox" 
            formControlName="commentFieldOnOptional"
            (change)="onChangeCommentFieldOnOptional($event)" />
        </div>
      </div>
    </div>    
    <!-- Options -->
    <div id="optionsBlock" class="metadata-block">
      <div class="metadata-title">Options</div>

      <div class="metadata-properties" fxLayout="row nowrap">
        <div class="metadata-key">Required</div>
        <input tabindex="1" type="checkbox" formControlName="reqCheck" id="reqCheck" />
      </div>

      <div class="metadata-properties" fxLayout="row nowrap">
        <div class="metadata-key">Validate On Blur</div>
        <input tabindex="1" type="checkbox" formControlName="validateOnBlur" id="validateOnBlur" />
      </div>

      <div class="metadata-properties" fxLayout="row nowrap">
        <div class="metadata-key">Suffix</div>
        <input tabindex="1" type="checkbox" formControlName="suffix" id="suffix" /> &nbsp;
        <input tabindex="1" class="float-left" formControlName="suffixText" class="metadata-input-field" type="text"
          [hidden]="!form?.get('suffix')?.value" />
      </div>

      <div class="metadata-properties" fxLayout="row nowrap">
        <div class="metadata-key">Prefix</div>
        <input tabindex="1" type="checkbox" id="prefix" formControlName="prefix" />
        <input tabindex="1" formControlName="prefixText" class="metadata-input-field" type="text"
          [hidden]="!form?.get('prefix')?.value" />
      </div>

      <div class="metadata-properties" fxLayout="row nowrap">
        <div class="metadata-key">onPaste</div>
        <input tabindex="1" type="checkbox" class="widget-attr" id="isPasteEnabled" formControlName="isPasteEnabled" />
      </div>

      <div class="metadata-properties" fxLayout="row nowrap">
        <div class="metadata-key">Alphanumeric</div>
        <input tabindex="1" type="radio" class="widget-attr" formControlName="isNumeric" [value]="false" />
        <div class="metadata-key">Numeric</div>
        <input tabindex="1" type="radio" class="widget-attr" formControlName="isNumeric" [value]="true" />
      </div>
      <div class="metadata-block">
        <div for="text" class="metadata-key">Min Length:</div>
        <div class="metadata-input-block">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input tabindex="1" fxFlex="flex-grow" id="minTextLength" formControlName="minTextLength" class="metadata-input-field"
            type="number" />
        </div>
        <div for="text" class="metadata-key">Max Length:</div>
        <div class="metadata-input-block">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input tabindex="1" fxFlex="flex-grow" id="maxTextLength" formControlName="maxTextLength" class="metadata-input-field"
            type="number" placeholder="{{ data.maxTextLength }}" />
        </div>
      </div>
      <div class="metadata-block" *ngIf="!data.isNumeric">
        <div for="text" class="metadata-key">Pattern:</div>
        <div class="metadata-input-block">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input tabindex="1" fxFlex="flex-grow" id="pattern" formControlName="pattern" class="metadata-input-field" type="text" />
        </div>
      </div>

      <div class="metadata-block" *ngIf="data.isNumeric">
        <div for="number" class="metadata-key">Min:</div>
        <div class="metadata-input-block">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input tabindex="1" fxFlex="flex-grow" id="minNum" formControlName="minNum" class="metadata-input-field" type="number"
            [ngClass]="{ disabledClass: form?.get('isMinCurrentYear')?.value }" />
        </div>
        <div for="number" class="metadata-key">Max:</div>
        <div class="metadata-input-block">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input tabindex="1" fxFlex="flex-grow" id="maxNum" formControlName="maxNum" class="metadata-input-field" type="number"
            [ngClass]="{ disabledClass: form?.get('isMaxCurrentYear')?.value }" />
        </div>
        <div class="metadata-properties" fxLayout="row nowrap">
          <div for="isMinCurrentYear" class="metadata-key">After current year</div>
          <input tabindex="1" type="checkbox" class="widget-attr" id="isMinCurrentYear" formControlName="isMinCurrentYear" />
          <div for="isMaxCurrentYear" class="metadata-key">Before current year</div>
          <input tabindex="1" type="checkbox" class="widget-attr" id="isMinCurrentYear" formControlName="isMaxCurrentYear"
            placeholder="{{ data.isMaxCurrentYear }}" />
          <div for="isDecimal" class="metadata-key">Decimal</div>
          <input tabindex="1" type="checkbox" id="isDecimal" class="widget-attr" formControlName="isDecimal" />
        </div>
      </div>
    </div>
    <div><appMetadataTemplate [primitive]="data" [template]="template" (modifiedJsonTemplate)="getModifiedTemplate($event)"></appMetadataTemplate></div>
  </div>